import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { API } from "@/App";
import apiAuth from "@/api/axios";

export default function AdminSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch settings on mount
  useEffect(() => {
    apiAuth.get(`${API}/settings`).then((res) => {
      setSettings(res.data);
      setLoading(false);
    });
  }, []);

  const handleChange = (field, value) => {
    setSettings((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    try {
      const { leave_settings, ...otherSettings } = settings;

  
      await apiAuth.put(`${API}/settings`, otherSettings);

 
      if (leave_settings) {
        await apiAuth.put(`${API}/settings/leave`, { balances: leave_settings });
      }

      alert("Settings updated successfully!");
    } catch (error) {
      console.error(error);
      alert("Failed to update settings");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>System Settings</h1>
          <p>Configure system-wide preferences for HR and operations.</p>
        </div>
      </div>

      <Card className="mt-6">
        <CardHeader>
          <CardTitle>General Settings</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
    
          <div className="space-y-2">
            <Label>Overhead Method</Label>
            <select
              value={settings.overhead_method}
              onChange={(e) =>
                handleChange("overhead_method", e.target.value)
              }
              className="border rounded-md p-2 w-full"
            >
              <option value="EQUAL_SPLIT">Equal Split</option>
              <option value="PROPORTIONAL_HOURS">Proportional Hours</option>
            </select>
          </div>

 
          <div className="space-y-2">
            <Label>Tolerance (minutes)</Label>
            <Input
              type="number"
              value={settings.tolerance_minutes}
              onChange={(e) =>
                handleChange("tolerance_minutes", Number(e.target.value))
              }
            />
          </div>

 
          <div className="flex items-center space-x-3">
            <Label>Biometric Enabled</Label>
            <input
              type="checkbox"
              checked={settings.biometric_enabled}
              onChange={(e) =>
                handleChange("biometric_enabled", e.target.checked)
              }
              className="h-4 w-4"
            />
          </div>
        </CardContent>
      </Card>
{/* 
      <Card className="mt-6">
        <CardHeader>
          <CardTitle>Monthly Operational Costs</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {Object.entries(settings.monthly_op_costs || {}).map(
            ([key, val], idx) => (
              <div key={idx} className="flex space-x-2">
                <Input value={key} readOnly className="bg-gray-100 w-1/2" />
                <Input
                  type="number"
                  value={val}
                  onChange={(e) => {
                    const newCosts = {
                      ...settings.monthly_op_costs,
                      [key]: Number(e.target.value),
                    };
                    handleChange("monthly_op_costs", newCosts);
                  }}
                  className="w-1/2"
                />
              </div>
            )
          )}
        </CardContent>
      </Card> */}

      <Card className="mt-6">
        <CardHeader>
          <CardTitle>Leave Settings</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {Object.entries(settings.leave_settings || {}).map(
            ([type, days], idx) => (
              <div key={idx} className="flex space-x-2">
                <Input value={type} readOnly className="bg-gray-100 w-1/2" />
                <Input
                  type="number"
                  value={days}
                  onChange={(e) => {
                    const newLeave = {
                      ...settings.leave_settings,
                      [type]: Number(e.target.value),
                    };
                    handleChange("leave_settings", newLeave);
                  }}
                  className="w-1/2"
                />
              </div>
            )
          )}
        </CardContent>
      </Card>

      {/* Save Button */}
      <div className="mt-6 flex justify-end">
        <Button onClick={handleSave}>Save Settings</Button>
      </div>
    </div>
  );
}
